import React from "react";
import * as Icons from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "store/auth";
import { IconLoader, isItemActive } from "./SideBar";

const NotificationBadge = ({ count }) =>
  Number(count) > 0 ? (
    <span className="mr-2 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-xs text-white">
      {count}
    </span>
  ) : null;

export default function MainMenu() {
  const location = useLocation();
  const auth = useAuth();
  const menus = (auth.userMeta?.panel_menus || []).filter((item) => item.allow);

  return (
    <nav className="top-nav" aria-label="منوی اصلی مدیریت">
      <ul>
        {menus.map((item) => {
          const children = (item.childs || []).filter((child) => child.allow);
          return (
            <li key={item.to || item.title}>
              <Link
                to={item.to}
                className={`top-menu ${isItemActive(location.pathname, item) ? "top-menu--active" : ""}`}
              >
                <span className="top-menu__icon">
                  <IconLoader name={item.icon} />
                </span>
                <span className="top-menu__title">
                  {item.title}
                  <NotificationBadge count={item.notification_count} />
                  {children.length ? <Icons.ChevronDown aria-hidden="true" className="top-menu__sub-icon" /> : null}
                </span>
              </Link>

              {children.length ? (
                <ul>
                  {children.map((child) => (
                    <li key={child.to || child.title}>
                      <Link to={child.to} className="top-menu">
                        <span className="top-menu__icon">
                          <IconLoader name={child.icon} />
                        </span>
                        <span className="top-menu__title">
                          {child.title}
                          <NotificationBadge count={child.notification_count} />
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
